var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllBg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 92,
    viewBox: "0 0 351 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3.62413e-06 0.178707L0 46.0424L46.7448 46.0424L46.7448 0.178702L-3.62413e-06 0.178707Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6842 0.0743217L46.6842 45.9381L93.429 45.9381L93.429 0.0743159L46.6842 0.0743217Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3684 0.134026L93.3684 45.9977L140.113 45.9977L140.113 0.13402L93.3684 0.134026Z",
    fill: "#2E2E2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6614 0.237425L93.306 11.6626L93.306 0.237424L81.6614 0.237425Z",
    fill: "#D62340"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0168 0.237358L58.3722 0.237359L93.306 34.5127L93.306 23.0876L70.0168 0.237358Z",
    fill: "#D62340"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7276 0.237497L93.306 45.938L81.6614 45.938L46.7276 11.6626L46.7276 0.237497Z",
    fill: "#D62340"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7275 23.0878L70.0167 45.938L58.3721 45.938L46.7275 34.5129L46.7275 23.0878Z",
    fill: "#D62340"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3188 0.175391L0.0286865 23.0266L23.3189 45.8778L46.609 23.0266L23.3188 0.175391Z",
    fill: "#2E2E2E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140.05 45.937L116.761 23.0867L140.05 0.236451L140.05 45.937Z",
    fill: "#FAFAFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M350.37 45.8638L350.37 1.52588e-05L327 1.81558e-05L327 45.8638L350.37 45.8638Z",
    fill: "#D62340"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M327.426 45.9392L327.426 0.0754852L280.681 0.075491L280.681 45.9392L327.426 45.9392Z",
    fill: "#2E2E2E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M280.742 45.9987L280.742 0.134964L233.997 0.13497L233.997 45.9987L280.742 45.9987Z",
    fill: "#2E2E2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M327.532 45.8637L327.532 2.95291e-07L280.787 6.08991e-06C280.787 25.4617 301.747 45.8637 327.532 45.8637Z",
    fill: "#FAFAFA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M327.531 34.4388L327.531 0.163411L292.598 0.163415C292.431 19.0965 308.068 34.4388 327.531 34.4388Z",
    fill: "#2E2E2E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M280.787 0.163224L257.498 23.0135L280.787 45.8637L280.787 0.163224Z",
    fill: "#FAFAFA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M350.289 1.55109e-05L327 22.8503L350.289 45.7005L350.289 1.55109e-05Z",
    fill: "#FAFAFA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M187.428 46.0424L187.428 0.17868L140.683 0.178687L140.683 46.0424L187.428 46.0424Z",
    fill: "#D62340"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M234.112 45.9827L234.112 0.118942L187.367 0.118949L187.367 45.9827L234.112 45.9827Z",
    fill: "#2E2E2E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M210.778 11.5289C204.347 11.5289 199.133 16.6441 199.133 22.954C199.133 29.2639 204.347 34.3791 210.778 34.3791C217.209 34.3791 222.423 29.2639 222.423 22.954C222.423 16.6441 217.209 11.5289 210.778 11.5289Z",
    fill: "#FAFAFA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M164.033 34.5425C157.546 34.5425 152.389 29.4828 152.389 23.1173C152.389 16.7519 157.546 11.6922 164.033 11.6922C170.521 11.6922 175.678 16.7519 175.678 23.1173C175.678 29.3195 170.521 34.5425 164.033 34.5425Z",
    fill: "#FAFAFA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M234 46.1042L234 91.9679L280.745 91.9679L280.745 46.1042L234 46.1042Z",
    fill: "#FAFAFA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M280.684 46L280.684 91.8638L327.429 91.8637L327.429 46L280.684 46Z",
    fill: "#FAFAFA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M327.368 46.0598L327.368 91.9236L350.738 91.9236L350.738 46.0598L327.368 46.0598Z",
    fill: "#2E2E2E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M315.661 46.1632L327.306 57.5883L327.306 46.1632L315.661 46.1632Z",
    fill: "#D62340"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M304.017 46.1632L292.372 46.1632L327.306 80.4386L327.306 69.0135L304.017 46.1632Z",
    fill: "#D62340"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M280.727 46.1632L327.306 91.8638L315.661 91.8638L280.727 57.5884L280.727 46.1632Z",
    fill: "#D62340"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M280.727 69.0135L304.017 91.8638L292.372 91.8638L280.727 80.4386L280.727 69.0135Z",
    fill: "#D62340"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M257.319 46.1011L234.028 68.9523L257.319 91.8035L280.609 68.9523L257.319 46.1011Z",
    fill: "#2E2E2E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllBg1);
export default __webpack_public_path__ + "static/media/allBg1.4a04c15ae320184bde95de7692bfc49e.svg";
export { ForwardRef as ReactComponent };